module.exports = __webpack_public_path__ + "static/media/Frame5.1f604369.jpg";